import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '../components/Main.vue'
import Mainphone from '../components/Mainphone.vue'
import Datastructure from '../components/datastructure.vue'
import Python from '../components/python.vue'
import Software from '../components/software.vue'

Vue.use(VueRouter)

const routes = [
  // 重定向
  {
    path: '/',
    name: 'index',
    meta: {
      title: '仇志金 Zhijin Qiu 齐鲁工业大学 山东省科学院海洋仪器仪表研究所'
    },
    redirect: '/main'
  },
  {
    path: '/main',
    name: 'index',
    meta: {
      title: '仇志金 Zhijin Qiu 齐鲁工业大学 山东省科学院海洋仪器仪表研究所'
    },
    component: Main
  },
  {
    path: '/main_phone',
    meta: {
      title: '仇志金 Zhijin Qiu 齐鲁工业大学 山东省科学院海洋仪器仪表研究所'
    },
    component: Mainphone
  },
  {
    path: '/datastructure',
    meta: {
      title: '数据结构 仇志金 Zhijin Qiu 齐鲁工业大学 山东省科学院海洋仪器仪表研究所'
    },
    component: Datastructure
  },
  {
    path: '/python',
    meta: {
      title: 'Python 仇志金 Zhijin Qiu 齐鲁工业大学 山东省科学院海洋仪器仪表研究所'
    },
    component: Python
  },
  {
    path: '/software',
    meta: {
      title: '科研软件'
    },
    component: Software
  },
  {
    path: '/news',
    redirect: '/'
  },
  {
    path: '/Projects',
    redirect: '/'
  },
  {
    path: '/Journal',
    redirect: '/'
  },
  {
    path: '/Conference',
    redirect: '/'
  },
  {
    path: '/Patents',
    redirect: '/'
  },
  {
    path: '/Teaching',
    redirect: '/'
  }
]
// 如果使用history模式，必须设置base参数 base: '/dist',
const router = new VueRouter({
  mode: 'history',
  base: '/~qiu/',
  routes
});

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace (location) {
  return originalReplace.call(this, location).catch(err => err)
}

// // 导航守护
// router.beforeEach((to, from, next) => {
//   // to 要去哪里
//   // from 来自哪里
//   // next放行函数
//   // next() 放行 next('/path')强制跳转到path
//   if (to.path === '/login') return next()
//   const tokenStr = window.sessionStorage.getItem('token')
//   if (!tokenStr) return next('/login')
//   next()
// })

export default router
